const AUTOMATION_CERTIFICATION_NAME_TEXTFIELD_ID = 'AUTOMATION_CERTIFICATION_NAME_TEXTFIELD_ID';
const AUTOMATION_CERTIFICATION_SHORTFORM_TEXTFIELD_ID = 'AUTOMATION_CERTIFICATION_SHORTFORM_TEXTFIELD_ID';

export { AUTOMATION_CERTIFICATION_NAME_TEXTFIELD_ID,
  AUTOMATION_CERTIFICATION_SHORTFORM_TEXTFIELD_ID };
